import ManageCookiesButton from './ManageCookiesButton';

export default ManageCookiesButton;
